<template>
  <list-table
    :url="url"
    title="لیست درخواست تسویه واسطه"
    :fields="fields"
    :params="params"
    :detailUrl="detailUrl"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
import persianDate from "../../helpers/persianDate";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "IndirectGatewayList",
  data() {
    return {
      url: "irwallet_sattlement_requestd",
      fields: [
        {
          key: "id",
          label: "کد درخواست",
        },
        {
          key: "wallet_name",
          label: "کیف پول",
        },
        {
          key: "bes",
          label: "مبلغ (ریال)",
          tdClass: "ltr",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },

        {
          key: "tracking_number",
          label: "کد رهگیری پرداخت",
        },

        {
          key: "created_at",
          label: "تاریخ و ساعت",
          formatter(value, key, item) {
            return (
              persianDate.getDateByFormat(value) +
              " , " +
              persianDate.getTime(value)
            );
          },
        },
        {
          key: "details",
          label: "جزییات",
        },
      ],
      detailUrl: "indirect_gateway_details",
      params: [],
    };
  },
  components: {
    "list-table": TableShowData,
  },
  computed: {},

  mounted() {
     this.$store.dispatch(SET_BREADCRUMB, [{ title: "درخواست تسویه واسطه" }]);
  },
  methods: {},
};
</script>
<style>
.ltr {
  direction: ltr;
}
</style>